export { default as IntegrationAttachmentDetail } from "./IntegrationAttachmentDetail";
